import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-import-confirm-dialog',
  templateUrl: './import-confirm-dialog.component.html',
  styleUrls: ['./import-confirm-dialog.component.scss']
})
export class ImportConfirmDialogComponent implements OnInit {

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<ImportConfirmDialogComponent>) { }

  ngOnInit(): void {
  }

  startImport()
  {
    this.dialogRef.close('import');
  }
}
